module.exports = __webpack_public_path__ + "static/img/wnlogo.eb7abd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wnlogo.png
// module id = ZmaS
// module chunks = 1